import React, { Component } from 'react';
import classnames from 'classnames';
import { injectIntl } from '@atlassian/jira-intl';
import {
	AkTextField,
	InlineDialog,
	InlineEdit,
	ListSkeleton,
	Tooltip,
} from '@atlassian/jira-portfolio-3-common';
import { REPORT } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/app';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';

import messages from './messages';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

// eslint-disable-next-line jira/react/no-class-components
class Title extends Component<Props> {
	onChangeTitle = (planTitle: string) => {
		const trimmedTitle = planTitle.trim();
		const { jiraTitle, onChange, intl } = this.props;

		const productName = intl.formatMessage(messages.plans);

		document.title = `${
			trimmedTitle || intl.formatMessage(messages.placeholder)
		} - ${productName} - ${jiraTitle}`;
		onChange(trimmedTitle);
	};

	validateTitle = (title: string) => {
		const trimmedTitle = title.trim();
		if (trimmedTitle.length <= 255) {
			return;
		}
		return this.props.intl.formatMessage(messages.tooLongInputErrorMessage);
	};

	render() {
		const { intl, isMultiScenarioEnabled, isReadOnly, mode, planScenarios, value } = this.props;

		if (!isDefined(value)) {
			return (
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				<div className={styles.skeletonContainer}>
					<ListSkeleton numOfRows={1} topPadding={2} />
				</div>
			);
		}

		const hasScenarios = !(
			isMultiScenarioEnabled !== true ||
			!isDefined(planScenarios) ||
			planScenarios.length < 1
		);

		const placeholder = intl.formatMessage(messages.placeholder);

		const classNames = classnames(styles.planTitleContainer, {
			[styles.withScenarios]: hasScenarios,
			[styles.isReadOnly]: isReadOnly && mode !== REPORT,
			[styles.isReportMode]: mode === REPORT,
		});
		return (
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			<div className={classNames} aria-label={intl.formatMessage(messages.planTitle)}>
				{isReadOnly === true ? (
					<Tooltip content={value}>
						{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
						<div className={styles.planTitleReadOnly}>{value}</div>
					</Tooltip>
				) : (
					<InlineEdit
						defaultValue={value}
						editView={({ errorMessage, ...fieldProps }) => (
							<InlineDialog content={errorMessage} isOpen={fieldProps.isInvalid} placement="right">
								<AkTextField
									{...fieldProps}
									testId="portfolio-3-portfolio.app-simple-plans.top.title-bar.title.input"
									autoFocus
									maxLength={256}
									placeholder={placeholder}
								/>
							</InlineDialog>
						)}
						onConfirm={this.onChangeTitle}
						readView={() => (
							<Tooltip content={value || placeholder}>
								{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
								<div className={styles.planTitleReadViewContainer}>
									{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
									<span className={styles.planTitle}>{value || placeholder}</span>
								</div>
							</Tooltip>
						)}
						// eslint-disable-next-line @typescript-eslint/no-shadow
						validate={(value) => this.validateTitle(value)}
					/>
				)}
			</div>
		);
	}
}

export default injectIntl(Title);
